import ViewHistorique from '@/views/consultations/historique/view-historique'
import { openMenu, closeMenu, open_menu_state } from '@/function/function.js';
import $ from 'jquery'
const PatientConsultationTimeline = () => import('./patient-consultation-timeline.vue')

export default {
    name: "historique",
    components: {
        ViewHistorique, PatientConsultationTimeline
    },
    props: [],
    data() {
        return {
            vm_state: open_menu_state,
            fields: [
                { key: "ref_bon", label: "Référence bon" }, { key: "ref_bon_parent", label: "Référence Parent" }, 
                { key: "type_consultation", label: "Type consultation" }, 'date', 'action.s'
            ],
            filter: "",
            perPage: 10,
            currentPage: 1,

            list_consultation_loading: true,
            list_consultation_empty: false,
            liste_consultations_patient: [],
            sequence_historique: 0,
            patient_historique_id: null,
            is_historique: false,
            selected_consultation: {},
            event_trigger: 0
        };
    },

    watch: {
        timeline_enabled() {
            this.sequence_historique++
            this.liste_consultations_patient = []
            this.selected_consultation = {}
            this.is_historique = false
            this.patient_historique_id = null
        },
        '$route.params.id'(patient_id, precedent) {
            if (String(patient_id) !== String(precedent)) this.getListConsultationPatien(patient_id)
        }
    },

    computed: {
        timeline_enabled() {
            const role = this.$store.getters['activeRole'] || {}
            return ['ROLE_MEDECIN', 'ROLE_INFIRMIER', 'ROLE_SAGE_FEMME'].includes(role.nom)
        },
        patient() {
            return this.$store.getters["patient"];
        },

        userCredentials() {
            return this.$store.getters["authInfo"];
        },

        consultation_length() {
            return this.liste_consultations_patient.length;
        },
    },

    mounted() {
        const patient_id = this.$route.params.id
        this.getListConsultationPatien(patient_id)

        $(document).bind('click', this.fermer_menu_historique)
    },

    beforeDestroy() {
        this.sequence_historique++
        if (typeof document !== 'undefined') $(document).unbind('click', this.fermer_menu_historique)
    },

    methods: {
        fermer_menu_historique(e) {
            if (!$(e.target).parents().hasClass('drp-container') && this.vm_state != 0) {
                this.openMenu(this.vm_state, 'drp-menu', 'animate-zoomIn', 'animate-zoomOut')
            }
        },

        /**
         * Open Menu Dropdown
         */
        async openMenu(state, selector, show_in, show_out) {
            this.vm_state = openMenu.dropMenu(state, selector, show_in, show_out)
        },

        /**
         * Close Menu Dropdown
         */
        async closeMenu(selector, show_in, show_out) {
            this.vm_state = closeMenu.wrapMenu(selector, show_in, show_out)
        },

        async getListConsultationPatien(patient_id) {
            // Les trois profils cliniques utilisent exclusivement la lecture patient autorisée.
            if (this.timeline_enabled) return
            const sequence = ++this.sequence_historique
            const actuel = () => !this._isDestroyed && sequence === this.sequence_historique
                && String(this.$route.params.id) === String(patient_id)
            this.list_consultation_loading = true
            this.list_consultation_empty = false
            this.liste_consultations_patient = []
            this.patient_historique_id = null
            this.is_historique = false
            this.selected_consultation = {}
            this.currentPage = 1

            try {
                const response = await this.$store.dispatch('getListeConsultationsPatient', { patient_id, lecture_locale: true })
                if (!actuel()) return
                if (!Array.isArray(response)) throw Error('Liste des consultations invalide')
                this.liste_consultations_patient = response
                this.patient_historique_id = String(patient_id)
                this.list_consultation_empty = response.length === 0
            } catch (error) {
                if (actuel()) {
                    this.list_consultation_empty = true
                    this.errorToast('Impossible de charger l’historique des consultations. Actualisez le dossier pour réessayer.')
                }
            } finally {
                if (actuel()) this.list_consultation_loading = false
            }
        },

        viewHistorique(data) {
            if (this._isDestroyed || this.list_consultation_loading
                || this.patient_historique_id !== String(this.$route.params.id)
                || !this.liste_consultations_patient.includes(data)) return
            this.event_trigger = (this.event_trigger == 0)?1:0
            this.is_historique = true
            this.selected_consultation = data
        },

        backToListConsultation() {
            this.is_historique = false
        }
    },
};
